import { render, staticRenderFns } from "./FinancialNavTabs.vue?vue&type=template&id=00056ee8"
import script from "./FinancialNavTabs.vue?vue&type=script&lang=js"
export * from "./FinancialNavTabs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports